/**
 * نوتیفِ مرورگر (Web Notification API) — اطلاع‌رسانیِ «پیام جدید» روی کامپیوتر/موبایل.
 *
 * نکته: فقط اطلاع‌رسانی است و **متنِ پیام** را نشان نمی‌دهد.
 */

const KEY = 'arjan_notif_enabled'

export const isSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window

export const permissionState = () =>
  isSupported() ? Notification.permission : 'unsupported'

export const isEnabled = () => {
  try {
    return localStorage.getItem(KEY) === '1' && isSupported() && Notification.permission === 'granted'
  } catch (e) {
    return false
  }
}

/** اجازه‌خواستن از کاربر برای نمایشِ نوتیف */
export const requestPermission = async () => {
  if (!isSupported()) return 'unsupported'
  try {
    const res = await Notification.requestPermission()
    if (res === 'granted') {
      try { localStorage.setItem(KEY, '1') } catch (e) { /* noop */ }
    }
    return res
  } catch (e) {
    return 'denied'
  }
}

export const disable = () => {
  try { localStorage.removeItem(KEY) } catch (e) { /* noop */ }
}

/**
 * نمایشِ نوتیف — عنوان: «پیام جدید» و متن: فقط نامِ فرستنده (بدونِ متنِ پیام).
 */
export const showMessageNotification = (fromName) => {
  if (!isEnabled()) return false
  try {
    const n = new Notification('پیام جدید', {
      body: fromName ? `پیام جدیدی از ${fromName} دارید` : 'پیام جدیدی دارید',
      tag: 'arjan-message',
      renotify: false,
      silent: false,
    })
    n.onclick = () => {
      try { window.focus() } catch (e) { /* noop */ }
      n.close()
    }
    return true
  } catch (e) {
    return false
  }
}
